// === IMPORT STYLE CSS / SCSS ===
import '@csstools/normalize.css';
import '../scss/main.scss';

// === IMPORT JS ===
// import './animations/ScrollSmoother';
import { initLenis } from './animations/ScrollLenis';
import NavHeight from './utils/nav-height';
import Nav from './layouts/nav';
import NavResponsive from './layouts/nav-responsive';
import Marquee from './animations/marquee';
import ColorDetect from './libs/colorDetect';
import VideoPlayers from './libs/videoPlayers';
import SwiperSliders from './libs/swiper';
import NumbersAnimations from './layouts/numbers-animations';
import SwitchTabs from './layouts/switch-tabs';
import Accordions from './layouts/accordions';
import Ajax from './layouts/ajax';
import cursorsAnimations from "./animations/cursorsAnimations";
import Forms from "./layouts/forms";
import ScrollNavHighlight from "./animations/ScrollNavHighlight";
import Selects from "./libs/selects";
import Pajolos from "./animations/pajolos";
import { animateTeamMembers } from './animations/animateTeam';
import AnchorsProjet from './animations/anchorsProjets.js';

const initScripts = () => {
    try {
        const nav = new Nav();
        initLenis((e) => nav.onScroll(e));
        new NavHeight();
        new NavResponsive();
        new Marquee();
        new SwiperSliders();
        new VideoPlayers();
        new NumbersAnimations();
        new SwitchTabs();
        new Accordions();
        new Ajax();
        new Forms();
        new Selects();
        new Pajolos();
        cursorsAnimations.initAll();
        ScrollNavHighlight.initAll();
        animateTeamMembers();
        new AnchorsProjet();
        if( document.querySelector('.post-item-projets') ) {
            new ColorDetect('.js-color-detect', 175);
        }
    } catch (error) {
        console.error("Erreur lors de l'initialisation des scripts :", error);
    }
}

document.addEventListener("DOMContentLoaded", initScripts);